import { useCallback } from 'react'
import { useActivitiesContext } from '../../../../context'
import { changeContentActionCreator } from '../../../../state'

export function useHandlers() {
  const [, dispatch] = useActivitiesContext()
  const handleCreateActivity = useCallback(() => {
    dispatch(changeContentActionCreator('form'))
  }, [dispatch])

  return {
    handleCreateActivity,
  }
}
